import { render, staticRenderFns } from "./RoomPreview.vue?vue&type=template&id=4a9dbcde&scoped=true&"
import script from "./RoomPreview.vue?vue&type=script&lang=ts&"
export * from "./RoomPreview.vue?vue&type=script&lang=ts&"
import style0 from "./RoomPreview.vue?vue&type=style&index=0&id=4a9dbcde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9dbcde",
  null
  
)

export default component.exports